import axios from 'axios';
import BaseApi from './base-api';
import { QualificationTypeEnum } from '../../domain/qualification-type-enum';

class QualificationsApi extends BaseApi {
  /**
   * Get qualifications
   * @param defaults: boolean (optional)
   * @return {Promise<{ok: boolean, proposal: any} | {ok: boolean, errors: *}>}
   */
  getQualifications(defaults) {
    let defaultFilter = '';
    if (defaults !== undefined && defaults) {
      defaultFilter = '?default=true';
    }

    return axios
      .get(`${this.baseUrl}/qualifications${defaultFilter}`)
      .then((response) => {
        return {
          ok: true,
          qualifications: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  /**
   *
   * @param type: QualificationTypeEnum
   * @param trade
   * @param label
   * @return {Promise<{ok: boolean, qualifications: any} | {ok: boolean, errors: *}>}
   */
  searchQualifications(type, trade, label) {
    if (type === undefined) {
      throw new Error('Qualification type is required');
    }
    if (label === undefined) {
      throw new Error('Qualification label is required');
    }

    if (type === QualificationTypeEnum.TRADE && trade === undefined) {
      throw new Error('Qualification trade is required');
    }

    let filter = '';
    switch (type) {
      case QualificationTypeEnum.GENERAL:
        filter = `${filter}?general=true&by_label=${label}`;
        break;

      case QualificationTypeEnum.TRADE:
        filter = `${filter}?by_trade=${trade}&by_label=${label}`;
        break;

      case QualificationTypeEnum.OTHER:
        filter = `${filter}?other=true&by_label=${label}`;
        break;

      default:
    }

    return axios
      .get(`${this.baseUrl}/qualifications${filter}`, {
        loadingDisabled: true,
      })
      .then((response) => {
        return {
          ok: true,
          qualifications: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  /**
   *
   * @param values: object {"type": string,"trade": number | undefined, "label": string, "options":[string]}"
   * @return {Promise<{ok: boolean, proposal: any} | {ok: boolean, errors: *}>}
   */
  createQualification(values) {
    const data = {
      qualification: {
        q_type: values.type,
        trade_id: values.trade,
        default: false,
        label: values.label,
        options: values.options,
      },
    };

    return axios
      .post(`${this.baseUrl}/qualifications`, data)
      .then((response) => {
        return {
          ok: true,
          qualification: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const qualificationsApi = new QualificationsApi();



// WEBPACK FOOTER //
// ./src/services/api/qualifications-api.js